import api from "./";

//retorna apenas os da empresa solicitada
export const checarCnhHandler = async (obj) => {
    try {
        const { data } = await api.post("/checarCnhHandler", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const obterCnhCategorias = async (obj) => {
    try {
        const { data } = await api.post("/obterCnhCategorias", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
